import * as React from "react";
import { Router, Route, Switch } from "react-router-dom";
import ReactDOM from "react-dom";
import "moment/locale/zh-cn";
import "antd/dist/antd.less";

import { createBrowserHistory } from "history";
import { createStore } from "@/stores";
import { project, direction } from "@/config.json";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "mobx-react";
import DevTool from "@/components/DevTool";

// Override styles
import "./index.less";
import Login from "@/pages/Login/index";
import Index from "@/pages/";

import { defaultLocale } from "@/config.json";

// prepare MobX stores
const history = createBrowserHistory();
export const rootStore = createStore(history);

import moment from "moment";
moment.locale("zh-cn");
import Spinner from "@/components/Spinner";
import CommonHeader from "@/components/CommonHeader";
import CommonFooter from "@/components/CommonFooter";
import { Layout, ConfigProvider } from "antd";
import enUS from "antd/es/locale/en_US";
import zhCN from "antd/es/locale/zh_CN";
import faIR from "antd/es/locale/fa_IR";
import { LangType } from "./stores/LocaleStore";

import ActiveModal from "./components/ActiveModal";

const CallCenter = React.lazy(() => import("@/pages/CallCenter"));
const MoreTool = React.lazy(() => import("@/pages/Home/MoreTool"));
const UserAgreementZH = React.lazy(() => import("@/pages/Attention/UserAgreement/UserAgreementZH"));
const UserAgreementEN = React.lazy(() => import("@/pages/Attention/UserAgreement/UserAgreementEN"));
const PrivacyPolicyZH = React.lazy(() => import("@/pages/Attention/PrivacyPolicy/PrivacyPolicyZH"));
const PrivacyPolicyEN = React.lazy(() => import("@/pages/Attention/PrivacyPolicy/PrivacyPolicyEN"));
const ObserVerPanel = React.lazy(() => import("@/pages/ObserverPanel"));
const TheLogin = React.lazy(() => import("@/pages/LoginBox/Login"));
const Register = React.lazy(() => import("@/pages/LoginBox/Register"));
const ForgetPassword = React.lazy(() => import("@/pages/LoginBox/ForgetPassword"));

const { Content } = Layout;

const localeMap = {
  [LangType.ZH]: zhCN,
  [LangType.EN]: enUS,
  [LangType.FA]: faIR,
};

ReactDOM.render(
  <Provider {...rootStore}>
    <DevTool>
      <Router history={history}>
        <Layout
          className={
            rootStore.session.isObservable ? `${project}-observer-layout` : `${project}-layout`
          }
        >
          <ConfigProvider
            locale={
              localeMap[rootStore.locale.lang] || localeMap[defaultLocale] || localeMap[LangType.ZH]
            }
            direction={direction as any}
          >
            <CommonHeader type="login" />
            <Content style={{ minHeight: "100vh" }}>
              <ActiveModal />
              <React.Suspense fallback={<Spinner />}>
                <Switch>
                  <Route exact path="/home" component={Login} />
                  <Route exact path="/service" component={CallCenter} />
                  <Route exact path="/sub/:key" component={ObserVerPanel} />
                  {/* <Route exact path="/about" component={About} /> */}
                  <Route exact path="/tool" component={MoreTool} />
                  <Route exact path="/privacyPolicyEN" component={PrivacyPolicyEN} />
                  <Route exact path="/privacyPolicyZH" component={PrivacyPolicyZH} />
                  <Route exact path="/userAgreementEN" component={UserAgreementEN} />
                  <Route exact path="/userAgreementZH" component={UserAgreementZH} />
                  <Route exact path="/login" component={TheLogin} />
                  <Route exact path="/register" component={Register} />
                  <Route exact path="/forget" component={ForgetPassword} />
                  <Route path="/" component={Index} />
                </Switch>
              </React.Suspense>
            </Content>
            <CommonFooter />
          </ConfigProvider>
          {/* <Safeguard /> */}
        </Layout>
      </Router>
    </DevTool>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
